import * as React from 'react';

const Filters24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7 3a2 2 0 0 0-2 2v1.5H1.75a.75.75 0 0 0 0 1.5H5v1.5a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V8h11.25a.75.75 0 0 0 0-1.5H11V5a2 2 0 0 0-2-2zm2 1.5a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5zM1 16.75a.75.75 0 0 1 .75-.75H13v-1.5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2V16h3.25a.75.75 0 0 1 0 1.5H19V19a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1.5H1.75a.75.75 0 0 1-.75-.75M15 14a.5.5 0 0 0-.5.5V19a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-4.5a.5.5 0 0 0-.5-.5z"
  }
));
Filters24.Size = 24;
Filters24.Title = "Filters";

export { Filters24 as default };
